import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

const EmissionTypeChart = ({ data }) => {
  const categories = ["Excellent", "Very Good", "Good", "Average", "Poor"];
  const values = categories.map((key) => data[key] || 0); // Ensure values are at least 0

  const capitalizeFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const myChartRef = chartRef.current.getContext("2d");

    const colorMap = {
      Excellent: "#fec757",
      "Very Good": "#6fbfba",
      Good: "#846bb5",
      Average: "#FF9800",
      Poor: "#a19f9f",
    };

    const backgroundColor = categories.map(
      (category) => colorMap[category] || "#D3D3D3"
    );

    chartInstance.current = new Chart(myChartRef, {
      type: "pie",
      data: {
        labels: categories.map((type) => capitalizeFirstLetter(type)),
        datasets: [
          {
            data: values,
            backgroundColor: backgroundColor,
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              usePointStyle: true,
              color: "black",
              padding: 20,
            },
          },
          tooltip: {
            callbacks: {
              label: (context) => `${context.raw.toFixed(2)}`,
            },
          },
          datalabels: {
            display: (context) => context.dataset.data[context.dataIndex] > 0,
            color: "white",
            font: {
              weight: "bold",
              size: 12,
            },
            formatter: (value) => value.toFixed(0),
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        aspectRatio: 2,
        layout: {
          padding: {
            bottom: 40,
          },
        },
      },
      plugins: [ChartDataLabels],
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  return <canvas ref={chartRef} />;
};

export default EmissionTypeChart;
